import React, { useState } from 'react';
import styled from 'styled-components';
import { useUser } from '../../../common/utils/hooks';
import { Body, Headline, Title } from '../../../shared/styled-components/styled_text';
import { FlexRow } from '../../../shared/FlexRow';
import { FlexCol } from '../../../shared/FlexCol';

type Menu = 'create' | 'invite';

interface Props {
  moveStep: (step: Menu) => void;
}

export const WelcomePc: React.FC<Props> = ({ moveStep }) => {
  const { user } = useUser();
  const [activeButton, setActiveButton] = useState<Menu>();

  const handleTouchStart = (menu: Menu) => setActiveButton(menu);
  const handleTouchEnd = (menu: Menu) => {
    setActiveButton(undefined);
    moveStep(menu);
  };

  const handleTouchCancel = () => setActiveButton(undefined);

  return (
    <Container>
      <Headline size={'m'} style={{ textAlign: 'center' }}>{`${user?.name ?? ''}님,\n캔디데이트 비즈 회원가입을 축하합니다~!`}</Headline>
      <FlexRow width={'100%'} justify={'center'} align={'center'} gap={'2.4rem'}>
        <ButtonContainer
          $active={activeButton === 'create'}
          onTouchStart={() => handleTouchStart('create')}
          onTouchEnd={() => handleTouchEnd('create')}
          onTouchCancel={handleTouchCancel}
          onMouseDown={() => handleTouchStart('create')}
          onMouseUp={() => handleTouchEnd('create')}
          onMouseLeave={handleTouchCancel}
        >
          <CharacterImage src={'/images/workspace-wizard/create_character.png'} />
          <FlexCol width={'fit-content'} justify={'center'} align={'center'} gap={'1.2rem'}>
            <Title size={'m'}>워크스페이스 생성하기</Title>
            <Body size={'m'}>
              새로 회사 정보를 등록하고
              <br />
              캔디데이트 비즈 사용하기
            </Body>
          </FlexCol>
        </ButtonContainer>
        <ButtonContainer
          $active={activeButton === 'invite'}
          onTouchStart={() => handleTouchStart('invite')}
          onTouchEnd={() => handleTouchEnd('invite')}
          onTouchCancel={handleTouchCancel}
          onMouseDown={() => handleTouchStart('invite')}
          onMouseUp={() => handleTouchEnd('invite')}
          onMouseLeave={handleTouchCancel}
        >
          <CharacterImage src={'/images/workspace-wizard/invite_character.png'} />
          <FlexCol width={'fit-content'} justify={'center'} align={'center'} gap={'1.2rem'}>
            <Title size={'m'}>초대 링크 입력하기</Title>
            <Body size={'m'}>
              동료가 공유해준 초대 링크
              <br />
              입력하고 사용하기
            </Body>
          </FlexCol>
        </ButtonContainer>
      </FlexRow>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding-top: -10rem;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3.2rem;
`;

const ButtonContainer = styled.div<{ $active?: boolean }>`
  width: fit-content;
  padding: 2.4rem;
  background-color: ${({ $active }) => ($active ? 'var(--primary-op-12)' : 'var(--background-1)')};
  border-radius: 12px;
  border: 2px solid ${({ $active }) => ($active ? 'var(--primary)' : 'var(--border-color)')};
  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2.4rem;

  &:hover {
    background-color: var(--primary-op-12);
  }
`;

const CharacterImage = styled.img`
  width: 20rem;
  height: 16rem;
`;
